import React from 'react'
const IconCasa = (props) => {
    return (
        <svg width="36" height="31" viewBox="0 0 36 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M29.25 9.8771V1.10714H23.625V5.15167L18 0L0 16.6071H4.5V31H14.625V19.9286H21.375V31H31.5V16.6071H36L29.25 9.8771Z" fill={props.color} />
        </svg>
    )
}
export default IconCasa